import styled from "styled-components";

const Container = styled.div`
margin: 0 auto;
width: 90%;
`

export {Container}